/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetAodScheduledRunsScheduledRunsForRuleQueryResponse, AuditReportsGetAodScheduledRunsScheduledRunsForRulePathParams, AuditReportsGetAodScheduledRunsScheduledRunsForRule401, AuditReportsGetAodScheduledRunsScheduledRunsForRule403, AuditReportsGetAodScheduledRunsScheduledRunsForRule404 } from "../models/AuditReportsGetAodScheduledRunsScheduledRunsForRule";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetAodScheduledRunsScheduledRunsForRule } from "../axios/auditReportsGetAodScheduledRunsScheduledRunsForRule";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetAodScheduledRunsScheduledRunsForRuleQueryKey = (ruleId: AuditReportsGetAodScheduledRunsScheduledRunsForRulePathParams["ruleId"]) => ["api-v2", { url: '/audit-reports/v1/aod-runs/scheduled/rules/:ruleId', params: {ruleId:ruleId} }] as const

export type AuditReportsGetAodScheduledRunsScheduledRunsForRuleQueryKey = ReturnType<typeof auditReportsGetAodScheduledRunsScheduledRunsForRuleQueryKey>

export function auditReportsGetAodScheduledRunsScheduledRunsForRuleQueryOptions(ruleId: AuditReportsGetAodScheduledRunsScheduledRunsForRulePathParams["ruleId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetAodScheduledRunsScheduledRunsForRuleQueryKey(ruleId)
        return queryOptions<AuditReportsGetAodScheduledRunsScheduledRunsForRuleQueryResponse, ResponseErrorConfig<AuditReportsGetAodScheduledRunsScheduledRunsForRule401 | AuditReportsGetAodScheduledRunsScheduledRunsForRule403 | AuditReportsGetAodScheduledRunsScheduledRunsForRule404>, AuditReportsGetAodScheduledRunsScheduledRunsForRuleQueryResponse, typeof queryKey>({
         enabled: !!(ruleId),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetAodScheduledRunsScheduledRunsForRule(ruleId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves all future scheduled runs (enqueued jobs) for a specific AOD rule
 * @summary Get scheduled runs for an AOD rule
 * {@link /audit-reports/v1/aod-runs/scheduled/rules/:ruleId}
 */
export function useAuditReportsGetAodScheduledRunsScheduledRunsForRule<TData = AuditReportsGetAodScheduledRunsScheduledRunsForRuleQueryResponse, TQueryData = AuditReportsGetAodScheduledRunsScheduledRunsForRuleQueryResponse, TQueryKey extends QueryKey = AuditReportsGetAodScheduledRunsScheduledRunsForRuleQueryKey>(ruleId: AuditReportsGetAodScheduledRunsScheduledRunsForRulePathParams["ruleId"], options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetAodScheduledRunsScheduledRunsForRuleQueryResponse, ResponseErrorConfig<AuditReportsGetAodScheduledRunsScheduledRunsForRule401 | AuditReportsGetAodScheduledRunsScheduledRunsForRule403 | AuditReportsGetAodScheduledRunsScheduledRunsForRule404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetAodScheduledRunsScheduledRunsForRuleQueryKey(ruleId)
         

         const query = useQuery({
          ...auditReportsGetAodScheduledRunsScheduledRunsForRuleQueryOptions(ruleId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetAodScheduledRunsScheduledRunsForRule401 | AuditReportsGetAodScheduledRunsScheduledRunsForRule403 | AuditReportsGetAodScheduledRunsScheduledRunsForRule404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}